import { render, staticRenderFns } from "./sellproductdetails.vue?vue&type=template&id=2d28f067&scoped=true"
import script from "./sellproductdetails.vue?vue&type=script&lang=js"
export * from "./sellproductdetails.vue?vue&type=script&lang=js"
import style0 from "./sellproductdetails.vue?vue&type=style&index=0&id=2d28f067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d28f067",
  null
  
)

export default component.exports